/** @format */

import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {
	homefieldIconAlertInfoOutlined,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';
import { NgOptimizedImage } from '@angular/common';

import { Chain } from '@shared/data-access/interfaces';

@Component({
	selector: 'scorecard-score-reward',
	templateUrl: './score-reward.component.html',
	styleUrl: './score-reward.component.scss',
	imports: [HomefieldIconLibraryModule, NgOptimizedImage],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScoreRewardComponent {
	readonly chain = inject(Chain);

	public scoreRewardIcon = 'assets/image/dsg_ScoreRewards_Card.svg';

	/* G3 doesn't have a /s/scorecard/scorerewards-credit-card, rest of the chains do */
	readonly link =
		this.chain.chainIdentifierAbbr === 'g3'
			? 'https://dickssportinggoods.com/s/scorecard/scorerewards-credit-card'
			: '/s/scorecard/scorerewards-credit-card';

	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconAlertInfoOutlined]);
	}
}
